import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { VcsAgentConnectionRow } from "../types";

const formatMetadata = (metadata: string | null | undefined) => {
  if (!metadata) {
    return "";
  }

  try {
    const parsed = JSON.parse(metadata) as Record<string, string>;

    return Object.entries(parsed)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", ");
  } catch {
    return metadata;
  }
};

const VCSAgentPoolAgentsTableMetadataCell = ({
  item: agentConnection,
  ...cellProps
}: TableSimpleCellProps<VcsAgentConnectionRow>) => {
  const metadata = formatMetadata(agentConnection.metadata);

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{metadata}</TableCellText>
    </TableSimpleCell>
  );
};

export default VCSAgentPoolAgentsTableMetadataCell;
